var render = function render() {
  var _vm$poiInfo$status_ta, _vm$poiInfo$shoptime$, _vm$poiInfo$shoptime$2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_vm.isWeiXin ? _c('div', {
    staticClass: "mapImg"
  }, [_c('feedMap', {
    attrs: {
      "map-options": _vm.mapOptions,
      "map-center": _vm.poiInfo.point || {},
      "is-map-feed-finished": _vm.isMapFeedFinished
    },
    on: {
      "overlay-add": _vm.overlayAdd
    }
  })], 1) : _vm._e(), _vm.poiInfo && _vm.poiInfo.name ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "poiImg"
  }, [_c('div', {
    staticClass: "img",
    style: {
      backgroundImage: `url(${_vm.poiInfo.image || 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/mapicons.png'})`
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.poiInfo.name))]), _c('div', {
    staticClass: "line line1"
  }, [_vm.poiInfo.score.score_num ? _c('div', {
    staticClass: "score",
    style: {
      color: _vm.poiInfo.score.font_color || '#11141a'
    }
  }, [_vm.poiInfo.score.icon_url ? _c('div', {
    staticClass: "formImg",
    style: {
      backgroundImage: `url(${_vm.poiInfo.score.icon_url})`
    }
  }) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.poiInfo.score.score_num))]), _vm._v("分 ")]) : _vm._e(), _c('div', {
    staticClass: "right"
  }, [_vm.poiInfo.comments_num ? _c('span', [_vm._v(_vm._s(_vm.poiInfo.comments_num) + "评价")]) : _vm._e(), (_vm$poiInfo$status_ta = _vm.poiInfo.status_tag) !== null && _vm$poiInfo$status_ta !== void 0 && (_vm$poiInfo$status_ta = _vm$poiInfo$status_ta.contents) !== null && _vm$poiInfo$status_ta !== void 0 && _vm$poiInfo$status_ta.length ? _vm._l(_vm.poiInfo.status_tag.contents, function (item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }) : _vm._e()], 2)]), _vm.poiInfo.address ? _c('div', {
    staticClass: "line line2"
  }, [_vm._v(" " + _vm._s(_vm.poiInfo.address) + " ")]) : _vm._e(), _vm.poiInfo.shoptime ? _c('div', {
    staticClass: "line line3"
  }, [(_vm$poiInfo$shoptime$ = _vm.poiInfo.shoptime.status) !== null && _vm$poiInfo$shoptime$ !== void 0 && (_vm$poiInfo$shoptime$ = _vm$poiInfo$shoptime$.data) !== null && _vm$poiInfo$shoptime$ !== void 0 && _vm$poiInfo$shoptime$.text ? _c('span', {
    staticClass: "status",
    style: {
      color: _vm.poiInfo.shoptime.status.data.textColor || '#11141a'
    }
  }, [_vm._v(" " + _vm._s(_vm.poiInfo.shoptime.status.data.text) + " ")]) : _vm._e(), (_vm$poiInfo$shoptime$2 = _vm.poiInfo.shoptime.content) !== null && _vm$poiInfo$shoptime$2 !== void 0 && _vm$poiInfo$shoptime$2.length ? _vm._l(_vm.poiInfo.shoptime.content, function (item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }) : _vm._e()], 2) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };